import React from 'react';
  


interface IProps {
  onClick ?: () => void
}
const DownloadIcon = ({onClick} :IProps) => {
  return (
    
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.31982 11.6797L11.8798 14.2397L14.4398 11.6797" stroke="#0055A8" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.8799 4V14.17" stroke="#0055A8" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20 12.1797C20 16.5997 17 20.1797 12 20.1797C7 20.1797 4 16.5997 4 12.1797" stroke="#0055A8" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


  );
};

export default DownloadIcon;